
import * as React from 'react'; // Importa React
import Accordion from '@mui/material/Accordion'; // Importa el componente Accordion para crear acordeones
import AccordionSummary from '@mui/material/AccordionSummary'; // Importa el componente AccordionSummary para la vista de resumen del acordeón
import AccordionDetails from '@mui/material/AccordionDetails'; // Importa el componente AccordionDetails para mostrar el contenido expandido del acordeón
import Typography from '@mui/material/Typography'; // Importa el componente Typography para manejar texto
import Link from '@mui/material/Link'; // Importa el componente Link para crear enlaces
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'; // Importa el icono para expandir el acordeón
import { Grid } from '@mui/system'; // Importa el componente Grid para crear diseños de cuadrícula

export default function Students(props) {
  
  console.log(props); // Imprime las props para depuración

  return (
    <div style={{width: "80%", marginLeft: "10%", marginTop: "7%"}}>
      <Typography variant="h4" marginBottom="5%" align='center'>
        Trabajo de estudiantes del Laboratorio
      </Typography>


      {/* Crea un acordeón para desplegar la información de un alumno */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Azalea Almazán Colotl</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails> {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://www.instagram.com/p/DcevPOwkWji/"> Proyecto </Link>
            </Grid>

          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Crea un acordeón para desplegar la información de un alumno */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Rodrigo Medellín Equihua</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails> {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/LabVS-IM-UNAM/sistemas-L"> Código </Link>
            </Grid>
            <Grid item xs={4}>
              <Link sx={{cursor:"pointer"}} onClick={()=> props.setTab(1)}> App </Link> {/* Al hacer click lleva a la segunda Tab */}
            </Grid>
            <Grid item xs={4}>
              <Link href="https://soundcloud.com/pepino-medellin"> Sonidos </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Crea un acordeón para desplegar la información de otro alumno */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Ricardo Mercado Valadez</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/ElZanate/Serv-social"> Código </Link>
            </Grid>
            <Grid item xs={4}>
              <Link href="https://elzanate.github.io/Serv-social/index.html"> App </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Crea un acordeón para desplegar la información de otro alumno */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Oswaldo Sánchez Arizmendi</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/Aratras16/Servicio_Social"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Crea un acordeón para desplegar la información de otro alumno */}
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Santiago Martínez Ávila</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/smavila00/Sonorizacion-de-Raices/"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

<Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Emilio Junoy de Juambelz</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/LabVS-IM-UNAM/Emilio"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

<Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Pablo de la Fuente Parres</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/LabVS-IM-UNAM/Pablo"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

<Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Dylan Alexis Facio Sicardo</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/LabVS-IM-UNAM/Dylan"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

<Accordion>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />} // Icono para expandir el acordeón
        >
          <Typography>Saúl Filiberto López Castillo</Typography> {/* Nombre del alumno */}
        </AccordionSummary>
        <AccordionDetails>  {/* Detalles del trabajo del alumno contenidos en un grid */}
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Link href="https://github.com/LabVS-IM-UNAM/Saul-"> Código </Link>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>


    </div>
  );
}

